import { PagesModule } from 'pages/pages.module';
import { NgModule } from '@angular/core';
import { ComponentsModule } from 'components/components.module';
import { AppSettingsPage } from 'pages/settings/app-settings-page';

@NgModule({
    declarations: [AppSettingsPage],
    imports: [PagesModule, ComponentsModule]
})
export class AppSettingsPageModule {}
